<script setup lang="ts">
import { ComboboxOption } from '@headlessui/vue'
const { history, clearHistory } = useCommandHistory()
</script>

<template>
  <div v-if="history?.length" class="border-t border-gray-100">
    <div class="px-4 py-2 bg-gray-50">
      <div class="flex items-center justify-between">
        <div class="flex items-center">
          <div class="i-heroicons-clock h-4 w-4 text-gray-400" />
          <span
            class="ml-2 text-xs font-medium text-gray-500 uppercase tracking-wider"
            >Recent</span
          >
        </div>
        <button
          @click="clearHistory"
          class="text-xs text-gray-400 hover:text-gray-600 transition-colors"
        >
          Clear
        </button>
      </div>
    </div>
    <div class="divide-y">
      <ComboboxOption
        v-for="item in history"
        :key="'history-' + item.id"
        :value="item"
        v-slot="{ active }"
        as="template"
      >
        <CommandPaletteItem :item="item" :active="active" />
      </ComboboxOption>
    </div>
  </div>
</template>
